import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { RankingCategoryItem, RankSortingLocatorComponent, RankSortingTypeEnum, ViewDataService, WaHelperService, WCupSeasonItem } from 'world-archery-lib';
import * as i0 from "@angular/core";
import * as i1 from "../../library/wa-services/view-data-service";
import * as i2 from "../../library/wa-services/wa-helper-service";
export class BaseService {
    constructor(views, helper) {
        this.views = views;
        this.helper = helper;
        /**
         *
         * Subject that constains all data avaible for show into the combobox of archers category
         * @type {Subject<Array<RankingCategoryItem>>}
         * @memberof FiltersSeriesEliteRankingService
         */
        this.worldCupRankingsCategoriesOptions = new BehaviorSubject([]);
        /**
         *
         * BehaviorSubject that retrieve the selected data into the combobox of archers category
         * @type {BehaviorSubject<RankingCategoryItem>}
         * @memberof FiltersSeriesEliteRankingService
         */
        this.worldCupRankingsCategories = new BehaviorSubject({});
        /**
         *
         * Subject that constains all data avaible for show into the season combobox of archers
         * @type {BehaviorSubject<WCupSeasonItem>}
         * @memberof FiltersSeriesEliteRankingService
         */
        this.worldCupRankingSeason = new BehaviorSubject({});
        /**
         *
         *  BehaviorSubject that retrieve the selected data into the combobox of archers category
         * @type {BehaviorSubject<Array<WCupSeasonItem>>}
         * @memberof FiltersSeriesEliteRankingService
         */
        this.worldCupRankingSeasonOptions = new BehaviorSubject([]);
        /**
         *
         * Subject that constains the text filters content.
         * @type {Subject<string>}
         * @memberof FiltersSeriesEliteRankingService
         */
        this.textFilter = new Subject();
        this.textSubject = new BehaviorSubject('');
        this._orderValue = undefined;
        this.sortLocator = new RankSortingLocatorComponent();
        this.orderSubject = new BehaviorSubject(this.sortLocator);
    }
    get textValue() {
        return this.textSubject.asObservable().pipe(debounceTime(500), distinctUntilChanged());
    }
    modifyTextValue(value) {
        this.textSubject.next(value);
    }
    get orderValue() {
        return this.orderSubject.asObservable();
    }
    modifyOrderValue() {
        this.orderSubject.next(this.sortLocator);
    }
}
BaseService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BaseService_Factory() { return new BaseService(i0.ɵɵinject(i1.ViewDataService), i0.ɵɵinject(i2.WaHelperService)); }, token: BaseService, providedIn: "root" });
